import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
// import { getCookie } from '../Helper/CookieHelper';
import ProjectReportsTabs from '../SecuredWorks/ProjectReport/ProjectReportTabs';
import MCReportView from './MCReportView';
// import TaskLevelAllocation2 from './TaskLevelAllocation2';
// import SecuredProjectRoles from '../SecuredProjectRoles';

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        backgroundColor: theme.palette.background.paper,
    },
}));

// const access = JSON.parse(getCookie("bb_ts_access"));

export default function MCReportTabs(props) {
    const classes = useStyles();
    const [value, setValue] = React.useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <div className={classes.root}>
            <AppBar position="static">
                <Tabs value={value} onChange={handleChange} aria-label="simple tabs example">
                    {/* <Tab label={props.value.psr1.timeline.name} {...a11yProps(0)} /> */}
                    <Tab label={"Current Period"} {...a11yProps(0)} />
                    <Tab label={props.value.psr2.timeline.name} {...a11yProps(1)} />
                    
                </Tabs>
            </AppBar>
            {/* <TabPanel value={value} index={0}>
                <ProjectReportsTabs value={props.value.psr1.data} />
            </TabPanel> */}
            <TabPanel value={value} index={0}>
                <MCReportView psr1={props.value.psr1.data} psr2={props.value.psr2.data} usage={props.value.psr2.data.usage_history} current_period_forecast={props.value.actual_forecast_for_current_period} />
            </TabPanel>
            <TabPanel value={value} index={1}>
                <ProjectReportsTabs value={props.value.psr2.data} />
            </TabPanel>
            
        </div>
    );
}
